import React, { useEffect } from 'react';
import Router from 'next/router';

const TaboolaFooter = () => {
  useEffect(() => {
    window._taboola = window._taboola || [];
    window._taboola.push({ flush: true });

    const handleRouteChangeComplete = () => {
      window._taboola = window._taboola || [];
      window._taboola.push({ flush: true });
    };

    Router.events.on('routeChangeComplete', handleRouteChangeComplete);
    return () => {
      Router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, []);

  return (<span />);
};

export default TaboolaFooter;
